export const getResultValue = (string, defValue) => {
  if (string === undefined || string === null || string === "") {
    if (typeof defValue !== "undefined") return defValue;
    return 0;
  }
  // 如果包含%
  if (String(string).includes("%")) {
    // 去掉%
    return parseFloat(string.replace("%", ""));
  }
  return Number(string);
};
